<script setup>
import { format, parseISO } from "date-fns";

const { application } = defineProps({
  application: Object,
});

const getDocumentByLabel = (label) => {
  const docs = application.studentApplicationDocuments;
  return docs.find((doc) => doc.label === label);
};

const formatDate = (isoDate) => {
  if (!isoDate) return "Invalid Date";
  return format(parseISO(isoDate), "d MMM, yyyy");
};

const getDocDownloadUrl = (key) => {
  const doc = application.studentApplicationDocuments?.find(
    (doc) => doc.label === key,
  );
  const url = doc?.media?.at(0)?.original_url;
  return url || null;
};

const getUserUploadedFileName = (rawFileName) => {
  return rawFileName.split("_")[1];
};
</script>

<template>
  <div class="bg-white rounded-xl drop-shadow-sm max-w-[600px]">
    <div class="flex gap-3 px-8 py-5 border-b border-slate-200">
      <Avatar size="large" :label="application?.university?.name?.at(0)" />
      <div>
        <h3 class="font-medium text-black">
          {{ application?.university?.name }}
        </h3>
        <p class="text-sm">
          <span class="pr-3 border-r border-slate-200">{{
            application?.program?.name
          }}</span>
          <span class="px-3 border-r border-slate-200">{{
            getCitiesName(application?.university?.cities) || "-"
          }}</span>
          <span class="px-3">
            {{ application?.university?.ranking?.name }}
            {{ application?.university?.ranking?.number }}</span
          >
          <i class="pi pi-star-fill text-[#EAB308]"></i>
        </p>
      </div>
    </div>
    <div class="px-8 pt-5 pb-8 space-y-4 text-sm">
      <p class="text-surface-900 font-semibold">
        Payment Receipt Uploaded Successfully 🎉
      </p>
      <p class="text-surface-900">
        {{
          `Your payment receipt has been successfully uploaded on ${formatDate(
            getDocumentByLabel("receipt")?.created_at,
          )}.
        Thank you for completing this step! We will now verify your document to
        ensure everything is in order and will update you as soon as possible.
        🚀`
        }}
      </p>
      <p class="text-surface-900">
        If you have any questions or need further assistance, feel free to
        contact us anytime.
      </p>
      <div class="flex items-center w-fit bg-gray-100 p-2 rounded-xl pr-8">
        <img src="~/assets/img/pdf.png" alt="PDF" class="w-12 h-12 mr-1" />
        <div class="text-left">
          <p class="font-semibold text-black">
            {{
              getUserUploadedFileName(getDocumentByLabel("receipt").input_value)
            }}
          </p>
          <a
            :href="getDocDownloadUrl('receipt')"
            target="_blank"
            class="text-blue-500 hover:text-blue-600"
            download
          >
            Download
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
